export const config = {
  title: "Abductive Services LLC | Drilling Fluid Monitoring in Bryan, TX",
  meta: {
    description:
      "Abductive Services LLC provides advanced drilling fluid monitoring solutions like Goblet Viscometers to optimize performance and safety during oil and gas drilling.",
    keywords: [
      "drilling fluid monitoring",
      "Goblet Viscometer",
      "oilfield instrumentation",
      "Abductive Services LLC",
      "Bryan TX oilfield services"
    ],
    author: "Abductive Services LLC",
    canonicalUrl: "https://abductiveservices.com/",
  },
  sections: {
    header: {
      businessName: "Abductive Services LLC",
    },
    sectionB: {
      heroTitle: "Abductive Services LLC",
      heroSubtitle: "Automated Fluid Property Monitoring for Safer, Smarter Drilling",
      learnAboutText: "Explore Our Solutions",
      phoneNumber: "18329527789",
      phoneLabel: "+1 (832) 952-7789",
      heroBackgroundImage:
        "https://media.istockphoto.com/id/2167016216/photo/engineering-teamwork-concept.jpg?s=612x612&w=0&k=20&c=l4fACKHngAlmUW73Fw6l1GDtwESIm7DqJAfge7-1iCw=",
      cardData: [
        {
          title: "Goblet Viscometer",
          description: "Explosion-proof and automated viscometer for drilling fluids.",
        },
        {
          title: "Real-Time Fluid Monitoring",
          description: "Continuously measure and report fluid properties while drilling.",
        },
        {
          title: "Custom Oilfield Solutions",
          description: "Tailored instrumentation and support for drilling operations.",
        },
      ],
      description:
        "Abductive Services LLC revolutionizes oilfield operations with real-time, automated drilling fluid measurement tools designed for performance and safety.",
    },
    sectionC: {
      servicesTitle: "Our Technology",
      servicesDescription:
        "We provide state-of-the-art measurement tools and oilfield instrumentation to improve drilling efficiency and safety.",
      cards: [
        {
          title: "Goblet Viscometer",
          description: "Explosion-proof system for continuous drilling fluid analysis.",
          imageSrc: "https://media.istockphoto.com/id/2155593440/photo/tank-ship-loading-unloading-oil-and-gasoline-at-commercial-dock-in-sea.jpg?s=612x612&w=0&k=20&c=ahEUInL4cKLghPYh0Qh1fcvkILLHqZ9fsOqs2FQ6Rk4=",
          imageAlt: "Goblet Viscometer",
        },
        {
          title: "System Integration",
          description: "Easily integrate with your drilling control systems.",
          imageSrc: "https://media.istockphoto.com/id/2150332096/photo/industrial-data-automation-system-on-computer.jpg?s=612x612&w=0&k=20&c=d8okNc0pMV0l32K3j6m8y_HxjNAM8h9_9oC59QBR2co=",
          imageAlt: "System Integration",
        },
        {
          title: "Data Logging & Reporting",
          description: "Automated data capture and reporting features built in.",
          imageSrc: "https://media.istockphoto.com/id/2142837168/photo/engineer-man-working-with-water-pipe-line-in-gas-oil-industry-workplace.jpg?s=612x612&w=0&k=20&c=Hf6WOJtnlxpgHJ7EL4_Sf_Qvn9pljBvilQLY5OVh7XY=",
          imageAlt: "Data Reporting",
        },

      ],
      otherServicesTitle: "Why Choose Us",
      otherServicesList: [
        "Explosion-Proof Rated Equipment",
        "Real-Time Data Transmission",
        "Reliable in Harsh Environments",
        "Field-Tested Durability",
        "Customizable for Your Operation",
      ],
    },
    sectionD: {
      aboutTitle: "About Abductive Services LLC",
      aboutImage: {
        src: "https://media.istockphoto.com/id/1310818458/photo/serious-handsome-engineer-using-a-laptop-while-working-in-the-oil-and-gas-industry.jpg?s=612x612&w=0&k=20&c=wuxjyy5FDAOLaCqEos3Blqs4wzaRse0VUpGYxMEgPfA=",
        alt: "Abductive Services Logo",
      },
      aboutText: [
        "Based in Bryan, TX, Abductive Services LLC is a leading provider of oilfield instrumentation, specializing in real-time drilling fluid monitoring systems.",
        "Our innovative Goblet Viscometer is designed for accuracy, durability, and field integration to support safe and efficient drilling operations.",
      ],
    },
    sectionE: {
      profileImage: "https://abductiveservices.com/wp-content/uploads/2025/06/logos-200x42.png",
      profileAlt: "Abductive Services LLC Logo",
      businessName: "Abductive Services LLC",
      contact: {
        phone: "18329527789",
        phoneLabel: "+1 (832) 952-7789",
        email: "sales@abductiveservices.com",
        website: "https://abductiveservices.com/",
        address: "1716 Briarcrest Drive, 3rd Floor, Bryan, Texas 77802, USA",
      },
      socialMedia: {},
    },
    sectionF: {
      address: "1716 Briarcrest Drive, 3rd Floor, Bryan, Texas 77802, USA",
      googleMapsEmbedUrl:
        "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3445.9382714263375!2d-96.34102438486234!3d30.660243596141385!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x864683dfd56f3b69%3A0x1e1510cc83c74709!2s1716%20Briarcrest%20Dr%2C%20Bryan%2C%20TX%2077802%2C%20USA!5e0!3m2!1sen!2sus!4v1724076489000",
    },
  },
};

export default config;
